import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@material-ui/core';
import { Container } from '@michelin/acid-components';
import { useTranslation } from '@michelin/central-provider';
import { ClosableDialogTitle } from 'components/ClosableDialog/ClosableDialogTitle';
import GLOBAL_CONFIG from 'global-variables';
import { useHistory, useLocation } from 'react-router-dom';

export function RequestServiceModule() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation<{ showComingSoonNotice?: boolean }>();
  const [noticeOpen, setNoticeOpen] = useState(!!location.state?.showComingSoonNotice);

  useEffect(() => {
    if (location.state?.showComingSoonNotice) {
      history.replace({ ...location, state: undefined });
    }
  }, [history, location]);

  return (
    <>
      {noticeOpen && (
        <Dialog onClose={() => setNoticeOpen(false)} maxWidth="md" fullWidth open>
          <ClosableDialogTitle onClose={() => setNoticeOpen(false)}>
            <span style={{ color: '#224173', fontWeight: 'bold' }}>{t('Request Service')}</span>
          </ClosableDialogTitle>
          <DialogContent>
            <DialogContentText style={{ color: '#000', fontSize: '1.25rem', lineHeight: 1.6, whiteSpace: 'pre-line' }}>
              {t('Coming soon in MyPortal')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setNoticeOpen(false)} color="primary" autoFocus>
              {t('Close')}
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <Container height="100%" spacing={0}>
        <iframe title="Request Service" src={GLOBAL_CONFIG.esdUrl} style={{ border: 'none', flex: 1 }} />
      </Container>
    </>
  );
}
